// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0070a61d","952":"23f0ad21"}[chunkId] + ".chunk.js";
};